import { Component, HostBinding, Inject } from '@angular/core';
import { IReportSettingsManager } from '@app/reports/report-settings/report-settings-manager.interface';
import { Logger } from '@app/logger/logger';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { getIdentifierForIterableItem } from '@app/shared/trackby.service';
import { hasValue } from '@app/shared/comparison-helpers.service';

@Component({
  selector: 'acs-setting-dialog',
  styleUrls: ['../../reports/report-settings/report-settings-dialog.scss'],
  templateUrl: '../../reports/report-settings/report-settings-dialog.html'
})
export class SettingDialogComponent {
  @HostBinding('class.acs-dialog-content-flexed') contentFlexedClass = true;
  public getIdentifierForIterableItem = getIdentifierForIterableItem;
  public showVisibleHeader = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { name: string; settings: IReportSettingsManager },
    private dialogRef: MatDialogRef<SettingDialogComponent>,
    private logger: Logger
  ) {
    if (!hasValue(data.settings)) {
      this.logger.warn('Report Settings dialog opened without any settings');
    }

    if (!hasValue(data.name)) {
      data.name = 'Settings';
    }

    data.settings.settingIds ? (this.showVisibleHeader = true) : (this.showVisibleHeader = false);
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  public close(): void {
    this.dialogRef.close(this.data.settings);
  }
}
